module.exports = __webpack_public_path__ + "static/L5Y5s-0d46f4764d4010be194b6f73ba1d8f14.jpg";